export default "__VITE_ASSET__CPopm6Ct__"